import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM, CUST_GRADIENTS } from '../../../../theme/customizer-tokens';

export const Card = styled.div<{ $selected: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  border: 1px solid ${({ $selected }) => ($selected ? CUST.accent : 'transparent')};
  border-radius: 22px;
  background: ${({ $selected }) => ($selected ? CUST_GRADIENTS.suggestionSelected : CUST.cardSurface)};
  cursor: pointer;
  transition: border-color ${CUST_ANIM.INTERACT_MS}ms ease;
`;

/** Full-bleed transparent button: the card's primary "select this name" hit area.
 *  It sits beneath the content (which is pointer-events:none) so a click anywhere
 *  on the card selects, while the inline "More" control re-enables pointer events
 *  and stays independently clickable (no invalid button-inside-button nesting). */
export const SelectHit = styled.button`
  position: absolute;
  inset: 0;
  z-index: 0;
  border: none;
  border-radius: 22px;
  background: transparent;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${CUST.accent};
    outline-offset: 2px;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 24px;
  pointer-events: none;
`;

export const Title = styled(Text)<{ $selected: boolean }>`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ $selected }) => ($selected ? CUST.accentText : CUST.eyebrowText)};
`;

/** Rationale preview. The trimmed text and the inline "More" flow as one
 *  paragraph, so "More" continues the sentence at the same size and reads as a
 *  natural part of the copy rather than a separate control below it. */
export const Desc = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${CUST.textMuted};
`;

/** Inline "More": same font-size as the rationale, accent-coloured. Buttons don't
 *  inherit fonts, so family/size/line-height are restated to match the text. */
export const MoreInline = styled.button`
  pointer-events: auto;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${CUST.accentText};
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  transition: filter ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    filter: brightness(1.15);
  }

  &:focus-visible {
    outline: 2px solid ${CUST.accent};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
